import { SxProps } from "@mui/material";
import { ClientIntegrationType, IntegrationType } from "~/operations";
import {
  AmazonS3Icon,
  AwsIcon,
  AzureDevopsIcon,
  AzureIcon,
  BigqueryIcon,
  CiscoIcon,
  CrowdstrikeIcon,
  DomainIcon,
  FlyingEnvelopeIcon,
  FortiOsIcon,
  GcpIcon,
  GcsBucketIcon,
  GithubIcon,
  GitlabIcon,
  GoogleWorkspaceIcon,
  HpeIcon,
  JiraIcon,
  KubernetesIcon,
  LinuxIcon,
  LongLivedCredsIcon,
  MacosIcon,
  Ms365Icon,
  MsftDefenderIcon,
  MsTeamsIcon,
  OciIcon,
  OktaIcon,
  PackerIcon,
  PanOsIcon,
  PostgreSqlIcon,
  SecurityPipelineIcon,
  SentinelOneIcon,
  ServiceNowIcon,
  ShodanIcon,
  SlackIcon,
  SnowflakeIcon,
  TelegramIcon,
  TerraformIcon,
  VmwareIcon,
  WebhookIcon,
  WindowsIcon,
  WorkstationIcon,
  ZendeskIcon,
} from "~/icons";
import { OtherIntegrations } from "~/pages/integrations/headers/types";

interface IntegrationDynamicIconProps {
  type: IntegrationType | OtherIntegrations | ClientIntegrationType;
  sx?: SxProps;
}

export function IntegrationDynamicIcon({
  type,
  sx,
}: IntegrationDynamicIconProps) {
  switch (type) {
    case IntegrationType.AwsS3: //fallthrough
    case IntegrationType.S3:
      return <AmazonS3Icon {...{ sx }} />;
    case IntegrationType.Azure:
      return <AzureIcon {...{ sx }} />;
    case IntegrationType.AzureBlob:
      return <AzureIcon {...{ sx }} />;
    case IntegrationType.Aws:
      return <AwsIcon {...{ sx }} />;
    case OtherIntegrations.LINUX:
      return <LinuxIcon {...{ sx }} />;
    case OtherIntegrations.CISCO:
      return <CiscoIcon {...{ sx }} />;
    case OtherIntegrations.PANOS:
      return <PanOsIcon {...{ sx }} />;
    case OtherIntegrations.FORTIOS:
      return <FortiOsIcon {...{ sx }} />;
    case OtherIntegrations.JUNOS:
      return <HpeIcon {...{ sx }} />;
    case IntegrationType.CrowdstrikeFalcon:
      return <CrowdstrikeIcon {...{ sx }} />;
    case IntegrationType.Oci:
      return <OciIcon {...{ sx }} />;
    case IntegrationType.Bigquery:
      return <BigqueryIcon {...{ sx }} />;
    case IntegrationType.MicrosoftDefender:
      return <MsftDefenderIcon {...{ sx }} />;
    case IntegrationType.Host:
      return <DomainIcon {...{ sx }} />;
    case IntegrationType.Snowflake:
      return <SnowflakeIcon {...{ sx }} />;
    case IntegrationType.Ms365:
      return <Ms365Icon {...{ sx }} />;
    case IntegrationType.Gcp:
      return <GcpIcon {...{ sx }} />;
    case IntegrationType.GcsBucket:
      return <GcsBucketIcon {...{ sx }} />;
    case IntegrationType.Okta:
      return <OktaIcon {...{ sx }} />;
    case IntegrationType.Gitlab:
      return <GitlabIcon {...{ sx }} />;
    case IntegrationType.Github:
      return <GithubIcon {...{ sx }} />;
    case IntegrationType.GoogleWorkspace:
      return <GoogleWorkspaceIcon {...{ sx }} />;
    case IntegrationType.TicketSystemJira:
      return <JiraIcon {...{ sx }} />;
    case IntegrationType.TicketSystemEmail:
      return <FlyingEnvelopeIcon {...{ sx }} />;
    case IntegrationType.TicketSystemZendesk:
      return <ZendeskIcon {...{ sx }} />;
    case IntegrationType.TicketSystemGithub:
      return <GithubIcon {...{ sx }} />;
    case IntegrationType.TicketSystemGitlab:
      return <GitlabIcon {...{ sx }} />;
    case IntegrationType.TicketSystemAzureDevops:
      return <AzureDevopsIcon {...{ sx }} />;
    case IntegrationType.TicketSystemServiceNow:
      return <ServiceNowIcon {...{ sx }} />;
    case IntegrationType.TicketSystemWebhook:
      return <WebhookIcon {...{ sx }} />;
    case IntegrationType.Postgres:
      return <PostgreSqlIcon {...{ sx }} />;
    case IntegrationType.K8S:
      return <KubernetesIcon {...{ sx }} />;
    case IntegrationType.Shodan:
      return <ShodanIcon {...{ sx }} />;
    case IntegrationType.SentinelOne:
      return <SentinelOneIcon {...{ sx }} />;
    case OtherIntegrations.WINDOWS:
      return <WindowsIcon {...{ sx }} />;
    case OtherIntegrations.MACOS:
      return <MacosIcon {...{ sx }} />;
    case OtherIntegrations.VMWARE:
      return <VmwareIcon {...{ sx }} />;
    case OtherIntegrations.PACKER:
      return <PackerIcon {...{ sx }} />;
    case OtherIntegrations.TERRAFORM:
      return <TerraformIcon {...{ sx }} />;
    case OtherIntegrations.CREDENTIALS:
      return <LongLivedCredsIcon {...{ sx }} />;
    case OtherIntegrations.WORKSTATION_MONDOO:
      return <WorkstationIcon {...{ sx }} />;
    case OtherIntegrations.CHATOPS_MSTEAMS:
    case OtherIntegrations.MSTEAMS:
      return <MsTeamsIcon {...{ sx }} />;
    case OtherIntegrations.CHATOPS_SLACK:
    case IntegrationType.HostedSlack:
    case OtherIntegrations.SLACK:
      return <SlackIcon {...{ sx }} />;
    case OtherIntegrations.CHATOPS_TELEGRAM:
    case OtherIntegrations.TELEGRAM:
      return <TelegramIcon {...{ sx }} />;
    case OtherIntegrations.CHATOPS_WEBHOOK:
    case OtherIntegrations.WEBHOOK:
      return <WebhookIcon {...{ sx }} />;
    case IntegrationType.SecurityPipelineGithub:
      return <SecurityPipelineIcon {...{ sx }} />;
    default:
      return <WorkstationIcon {...{ sx }} />;
  }
}
